import * as React from "react";
import type { ReactUiPaintTimingProps } from "./ReactUiPaintTiming.Props";
import { UiPaintTiming } from "../../UiPaintTiming";

/**
 * Create a minimal DOM element which enables tracking paint time of the react component using Element Timing API
 * @param props: ReactUiPaintTimingProps
 *
 * props.elementTimingId: the id of the element timing observer - used to correlate with the track call in the interactivity tracker
 * props.hidden: if true, the element will not be rendered to the DOM.
 *
 * Use hidden to re-measure elements that are already in the DOM but having their visibility toggled.
 */
export class ReactUiPaintTiming extends React.PureComponent<
  ReactUiPaintTimingProps,
  {}
> {
  constructor(props: ReactUiPaintTimingProps) {
    super(props);
  }

  public render() {
    const {
      elementTimingId,
      hidden = false,
      interactivityTrackerContext,
    } = this.props;

    return UiPaintTiming.getReactElement(
      elementTimingId,
      interactivityTrackerContext,
      hidden
    );
  }
}
